import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl-next';

import { ExitingPersistence, FadeIn } from '@atlaskit/motion';
import { Box, Text } from '@atlaskit/primitives/compiled';

import { messages } from '../../messages.ts';
import { ManualBulkCreateLoadingImage } from '../../assets/ManualBulkCreateLoadingImage.tsx';

const loadingMessages = [
	messages.manualBulkCreateLoadingTextFirst,
	messages.manualBulkCreateLoadingTextSecond,
	messages.manualBulkCreateLoadingTextThird,
];

export const BulkCreateManualLoading = () => {
	const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

	useEffect(() => {
		// Creates a 1.5 second interval between rotating the three text options contained in loadingMessages
		const intervalId = window.setInterval(() => {
			setLoadingMessageIndex((prev) => (prev + 1) % loadingMessages.length);
		}, 1500);

		return () => window.clearInterval(intervalId);
	}, []);

	return (
		<>
			<ManualBulkCreateLoadingImage />
			<ExitingPersistence exitThenEnter>
				<FadeIn entranceDirection="right" duration="large">
					{(motionProps) => (
						<Box {...motionProps}>
							<Text>
								<FormattedMessage {...loadingMessages[loadingMessageIndex]} />
							</Text>
						</Box>
					)}
				</FadeIn>
			</ExitingPersistence>
		</>
	);
};
